import type { FC, PropsWithChildren } from 'react';
import { showPromatDialog } from '~/signalsAndContext/global';

export type PromptDialogProps = PropsWithChildren<{
  onConfirm: () => void;
  renderContent?: () => React.ReactNode,
  onClose?: () => void;
  btnText?: string;
  showCloseIcon?: boolean;
  title?: string;
  btnConcelText?: string;
  showCancel?: boolean;
  clsName?: string;
}>;

export const PromptDialog: FC<PromptDialogProps> = ({
  onClose,
  onConfirm,
  btnText = 'Confirm',
  title = 'Warn',
  showCloseIcon = true,
  btnConcelText,
  showCancel,
  children,
  clsName,
  renderContent
}) => {
  const handleCloseDialog = () => {
    showPromatDialog.value = null;
    onClose?.();
  };

  const handleTapBtn = async () => {
    await onConfirm();
    showPromatDialog.value = null;
  };

  return (
    <div className="prompt-dialog">
      <div className={`prompt-dialog__wrapper ${clsName}`}>
        {showCloseIcon ? (
          <div className="prompt-dialog__close" onClick={handleCloseDialog}>
            <img src="~/images/awards2024/close_light.svg" alt="" className='close-icon' />
          </div>
        ) : null}
        <div className="prompt-dialog__head">
          <h4 className="prompt-dialog__title">{title}</h4>
        </div>
        <div className="prompt-dialog__main">
          {renderContent ? renderContent() : children}
        </div>
        <div className="prompt-dialog__footer">
          {showCancel ? (
            <button className="prompt-btn btn-default" type="button" onClick={handleCloseDialog}>
              {btnConcelText || 'Cancel'}
            </button>
          ) : null}
          <button className="prompt-btn btn-primary" type="button" onClick={handleTapBtn}>
            {btnText}
          </button>
        </div>
      </div>
    </div>
  );
};
